import i18n from '@i18n';

/**
 * Returns true with the given probability percentage (between 0 and 100).
 * @param {number} probability - A number between 0 and 100 representing a percentage chance.
 * @returns {boolean} True with the given probability.
 */
export function isInVariant(probability: number): boolean {
	if (probability < 0 || probability > 100) {
		throw new Error(i18n.t('error.probabilityError'));
	}

	return Math.random() < (probability / 100);
}
